<div class="ssb-root" *ngIf="status">
  <button
    type="button"
    class="ssb-chip"
    data-testid="store-status-chip"
    [class.ssb-chip--closed]="closed"
    [class.ssb-chip--active]="open"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    aria-haspopup="dialog"
    [matTooltip]="'STORE_STATUS.TOOLTIP' | translate"
    matTooltipClass="cl-action-tooltip"
    [matTooltipShowDelay]="200"
    matTooltipPosition="below"
  >
    <span class="ssb-dot"></span>
    <span class="ssb-chip__label">
      <ng-container *ngIf="!closed">{{ "STORE_STATUS.OPEN" | translate }}</ng-container>
      <ng-container *ngIf="closed && reopensAtText">{{ "STORE_STATUS.CLOSED_UNTIL" | translate: { time: reopensAtText } }}</ng-container>
      <ng-container *ngIf="closed && !reopensAtText">{{ "STORE_STATUS.CLOSED" | translate }}</ng-container>
    </span>
  </button>

  <div class="ssb-panel" *ngIf="open" role="dialog" [attr.aria-label]="'STORE_STATUS.TITLE' | translate">
    <header class="ssb-panel__header">
      <span class="ssb-panel__title">{{ "STORE_STATUS.TITLE" | translate }}</span>
      <span class="ssb-panel__state" [class.ssb-panel__state--closed]="closed">
        <ng-container *ngIf="!closed">{{ "STORE_STATUS.OPEN_HINT" | translate }}</ng-container>
        <ng-container *ngIf="closed && status.reason === 'HOURS'">{{ "STORE_STATUS.CLOSED_HOURS" | translate: { time: reopensAtText } }}</ng-container>
        <ng-container *ngIf="closed && status.reason !== 'HOURS'">
          {{ (reopensAtText ? "STORE_STATUS.CLOSED_MANUAL_UNTIL" : "STORE_STATUS.CLOSED_MANUAL") | translate: { time: reopensAtText } }}
        </ng-container>
      </span>
    </header>

    <div class="ssb-panel__body">
      <button
        *ngIf="status.manualClosed"
        type="button"
        class="ssb-action ssb-action--primary"
        data-testid="store-reopen"
        [disabled]="saving"
        (click)="reopen()"
      >
        {{ "STORE_STATUS.REOPEN" | translate }}
      </button>

      <ng-container *ngIf="!status.manualClosed">
        <div class="ssb-section-label">{{ "STORE_STATUS.CLOSE_FOR" | translate }}</div>
        <div class="ssb-durations">
          <button
            *ngFor="let minutes of durations"
            type="button"
            class="ssb-action ssb-action--pill"
            [disabled]="saving"
            (click)="closeFor(minutes)"
          >
            {{ (minutes < 60 ? "STORE_STATUS.MINUTES" : "STORE_STATUS.HOURS") | translate: { count: minutes < 60 ? minutes : minutes / 60 } }}
          </button>
        </div>
        <button *ngIf="status.hasHours" type="button" class="ssb-action" [disabled]="saving" (click)="closeUntilNextOpening()">
          {{ "STORE_STATUS.UNTIL_NEXT_OPENING" | translate }}
        </button>
        <button type="button" class="ssb-action" data-testid="store-close" [disabled]="saving" (click)="closeUntilReopened()">
          {{ "STORE_STATUS.UNTIL_REOPENED" | translate }}
        </button>
      </ng-container>

      <label class="ssb-follow" [class.ssb-follow--disabled]="!status.hasHours && !status.followHours">
        <input
          type="checkbox"
          [checked]="!!status.followHours"
          [disabled]="saving || (!status.hasHours && !status.followHours)"
          (change)="setFollowHours($any($event.target).checked)"
        />
        <span>
          <span class="ssb-follow__title">{{ "STORE_STATUS.FOLLOW_HOURS" | translate }}</span>
          <span class="ssb-follow__hint">
            {{ (status.hasHours ? "STORE_STATUS.FOLLOW_HOURS_HINT" : "STORE_STATUS.NO_HOURS_HINT") | translate }}
          </span>
        </span>
      </label>

      <!-- Where the hours are set: opens the same work-hours drawer as Settings > Company -->
      <button
        type="button"
        class="ssb-hours"
        data-testid="store-work-hours"
        [disabled]="openingHours"
        (click)="openWorkHours()"
      >
        <i class="fa-regular fa-clock ssb-hours__icon" aria-hidden="true"></i>
        <span class="ssb-hours__text">
          <span class="ssb-hours__title">{{ "STORE_STATUS.WORK_HOURS" | translate }}</span>
          <span class="ssb-hours__hint">
            {{ (status.hasHours ? "STORE_STATUS.WORK_HOURS_EDIT" : "STORE_STATUS.WORK_HOURS_ADD") | translate }}
          </span>
        </span>
        <i class="fa-solid ssb-hours__chevron" [ngClass]="openingHours ? 'fa-spinner fa-spin' : 'fa-chevron-right'" aria-hidden="true"></i>
      </button>
      <p class="ssb-error" *ngIf="noNumber">{{ "STORE_STATUS.NO_NUMBER" | translate }}</p>

      <p class="ssb-error" *ngIf="error">{{ "STORE_STATUS.ERROR" | translate }}</p>
    </div>
  </div>
</div>
